<template>
    <main class="unsubscribe-page max-width-container">
        <h1 class="form-title">Email notifications</h1>
        <div class="basic-form">
            <p v-if="subscribed" class="form-message">
                You currently receive emails about shares and friend requests.
            </p>
            <p v-else class="form-message">
                You will no longer receive emails about shares and friend
                requests. They still appear in your notifications in the app.
            </p>
            <p v-if="failed" class="form-message">
                Something went wrong. Try again.
            </p>
            <div class="actions">
                <Bttn v-if="subscribed" @click="unsubscribe">Unsubscribe</Bttn>
                <Bttn v-else @click="resubscribe">Subscribe again</Bttn>
                <router-link to="/settings">
                    <Bttn class="outlined">Settings</Bttn>
                </router-link>
            </div>
        </div>
    </main>
</template>

<script>
import { useUserStore } from "js/stores/userStore";

export default {
    name: "Unsubscribe",
    data() {
        return {
            store: null,
            subscribed: true,
            failed: false,
        };
    },
    mounted() {
        this.store = useUserStore();
    },
    methods: {
        unsubscribe() {
            this.failed = false;
            this.store
                .create(this.$route.fullPath)
                .then(() => {
                    this.subscribed = false;
                })
                .catch(() => {
                    this.failed = true;
                });
        },
        resubscribe() {
            this.failed = false;
            this.store
                .delete(this.$route.fullPath)
                .then(() => {
                    this.subscribed = true;
                })
                .catch(() => {
                    this.failed = true;
                });
        },
    },
};
</script>
